import React from "react";

import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const CallUs = () => {
  return (
    <div className="w-[88%] mx-auto my-16 mt-24">
      {/* Section label */}
      <p className="font-popinsMedium text-sm uppercase tracking-widest text-paraColor text-center mb-10">
        Get Started With FMS
      </p>

      <div className="flex flex-col lg:flex-row gap-6">
        {/* Book a demo card */}
        <div className="lg:w-[49%] bg-[#00051A] rounded-[28px] text-white py-12 px-8 flex flex-col items-center text-center">
          <p className="font-popinsRegular text-white/50 text-xs uppercase tracking-widest mb-4">
            Free — No Obligation
          </p>
          <p className="font-popinsBold text-3xl md:text-4xl lg:text-[2.6rem] leading-tight mb-4">
            Book a 30-Minute <br /> Product Demo
          </p>
          <p className="font-popinsMedium text-base text-white/70 mb-8 leading-relaxed max-w-sm">
            See FMS in action with a live walkthrough tailored to your flex space portfolio. Our team will answer every question.
          </p>
          <Link to="/request-demo">
            <button className="group relative inline-flex items-center gap-5 rounded-full bg-[#F0F2F4] pl-8 pr-[6px] py-2 text-sm font-medium text-black transition-all duration-300 hover:bg-white hover:shadow-lg">
              <span className="text-textColor font-popinsMedium text-sm md:text-base">
                Pick a Time That Works
              </span>
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white transition-all duration-300 group-hover:translate-x-1 group-hover:shadow">
                <ArrowRight className="w-4 h-4 text-black" />
              </span>
            </button>
          </Link>
        </div>

        {/* How it works card */}
        <div className="lg:w-[49%] bg-themeColor rounded-[28px] py-12 px-8 flex flex-col items-center text-center text-white">
          <p className="font-popinsRegular text-white/50 text-xs uppercase tracking-widest mb-4">
            Platform Overview
          </p>
          <p className="font-popinsBold text-3xl md:text-4xl lg:text-[2.6rem] leading-tight mb-4">
            See How FMS <br /> Works
          </p>
          <p className="font-popinsMedium text-base text-white/80 mb-8 leading-relaxed max-w-sm">
            Explore the full platform walkthrough — from lease creation and rent collection to maintenance tracking and reporting.
          </p>
          <Link to="/why-flex">
            <button className="group relative inline-flex items-center gap-5 rounded-full bg-[#F0F2F4] pl-8 pr-[6px] py-2 text-sm font-medium text-black transition-all duration-300 hover:bg-white hover:shadow-lg">
              <span className="text-textColor font-popinsMedium text-sm md:text-base">
                Explore the Platform
              </span>
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white transition-all duration-300 group-hover:translate-x-1 group-hover:shadow">
                <ArrowRight className="w-4 h-4 text-black" />
              </span>
            </button>
          </Link>
        </div>
      </div>

      {/* Contact bar */}
      <div className="bg-[#F0F2F4] rounded-[28px] flex flex-col items-center py-10 px-8 mt-6">
        <p className="text-xl md:text-2xl lg:text-3xl text-center font-popinsBold text-darkColor">
          Prefer to Talk First?
        </p>
        <p className="font-popinsMedium text-paraColor text-base md:text-lg mt-2 mb-7">
          Our team typically responds within one business hour.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <a
            href="tel:18883801955"
            className="group relative inline-flex items-center justify-between rounded-full bg-[#1D1D1F] pl-10 pr-[6px] py-2 text-sm font-medium transition-all duration-300 hover:bg-white hover:text-black hover:border hover:border-[#1D1D1F] shadow text-white hover:shadow-md gap-6"
          >
            <span className="font-popinsMedium">1-888-380-1955</span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white group-hover:bg-[#1D1D1F] transition-all duration-300 group-hover:translate-x-1 group-hover:shadow">
              <ArrowRight className="w-4 h-4 text-black group-hover:text-white" />
            </span>
          </a>
          <a
            href="mailto:support@theflexmanager.com"
            className="group relative inline-flex items-center justify-between rounded-full bg-[#1D1D1F] pl-10 pr-[6px] py-2 text-sm font-medium transition-all duration-300 hover:bg-white hover:text-black hover:border hover:border-[#1D1D1F] shadow text-white hover:shadow-md gap-6"
          >
            <span className="font-popinsMedium">support@theflexmanager.com</span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white group-hover:bg-[#1D1D1F] transition-all duration-300 group-hover:translate-x-1 group-hover:shadow">
              <ArrowRight className="w-4 h-4 text-black group-hover:text-white" />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default CallUs;
